import React, { Component } from 'react'
import BooksList from './BooksList';
import { connect } from 'react-redux'
import { fetchInitialData, togglePrimary } from '../../actions/SamplePage';
import Search from './Search';
import { Link } from 'react-router-dom';
import { Container } from '@material-ui/core';
import Filter from './Filters';
import SampleTabLinks from './sampleTabLinks';
import NoResultFound from './NoResultFound';
import CircularProgress from '@material-ui/core/CircularProgress';



class SamplePage extends Component {
    componentDidMount() {
        const category = this.props.match.params.category;
        const isPrimary = category === "primary";
        this.props.fetchInitialData(isPrimary);
    }

    togglePrimary = (view)=> {
        this.props.togglePrimary(view.target.id)
    }

    isFilterApplied = ()=>{
        const {year, state, subject}  = this.props.filter.value
        return (Boolean(year) || Boolean(state) || Boolean(subject))  
    }
    render() {
        console.log(this.props.match);
        
        const isPrimary = this.props.match.params.category === "primary";
        const {home, sample, secondary, primary, viewSample, buyNow,errorLabel, errorSubText,
            noResultFound,noResultFoundSubText,emptyListLabel,filterNoBookSubText} = this.props.language;
        const {loading, books, renderingList} = this.props;
        const {catergories} = books.indexes;
        const primaryCount = catergories && catergories.primary && catergories.primary.length;
        const secondaryCount = catergories  && catergories["secondary"] && catergories.secondary.length;
        return (
            <div>
                <div className="nav-breadcrumbs-outer">
                <Container>
                <div className="nav-breadcrumbs clearfix">
                    <nav className="breadcrumbs">
                        <Link to="/" >{home}</Link><span class="arrow-breadcrumb">&gt;</span><Link to="/samples">{sample}</Link>
                    </nav>
                    <h1>{sample}</h1>
                </div>
                </Container>
                </div>


                <Container>

                <div className="nav-breadcrumbs clearfix nav-tabs-secondary">
                    <SampleTabLinks isPrimary primaryCount={primaryCount} secondaryCount={secondaryCount}
                        togglePrimary={this.togglePrimary} 
                        language={{secondary,primary}}/>

                    <div className="filters-right">
                        {!isPrimary? <Filter className="pull-left" isDiabled={renderingList && renderingList.length === 0} />: ""}
                        <Search isDiabled={renderingList && renderingList.length === 0} />
                    </div>
                </div>
                {loading? <CircularProgress  />:(renderingList && renderingList.length === 0)? <NoResultFound 
                    fromError={Boolean(this.props.errorMsg)}
                    fromSearch={Boolean(this.props.searchKey)} 
                    fromFilters={this.isFilterApplied()} 
                    language={{noResultFound,noResultFoundSubText,emptyListLabel,filterNoBookSubText,errorLabel, errorSubText}}/> :
                    <BooksList books={books} renderingList={renderingList} language={{viewSample, buyNow}}/>
                }
            </Container>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProp) => {
    const {SamplePage} = state;
    const {home, sample, secondary, primary, viewSample, errorLabel, errorSubText,
        buyNow,noResultFound,noResultFoundSubText,emptyListLabel,filterNoBookSubText} = state.Language
    return {...SamplePage, language:{home, sample, secondary, primary, errorLabel, errorSubText,
        viewSample, buyNow,noResultFound,noResultFoundSubText,emptyListLabel,filterNoBookSubText}}
}

const mapDispatchToProps = (dispatch) => {
    return {
        fetchInitialData: (payload) => { dispatch(fetchInitialData(payload)) },
        togglePrimary: (payload) => { dispatch(togglePrimary(payload)) }
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(SamplePage)
